const loginLocale = {
  login: {
    login: "Connexion",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    welcome: "Bienvenue",
    connectToYourAccount: "Connectez vous à votre compte",
    logout: "Déconnexion",
  },
};

export type LoginLocale = typeof loginLocale;
export default loginLocale;
